import api from "./api";


export const getApiKeys = (params = {}) => api.get("/api-key/requests", { params });

export const addApiKey = (payload) => api.post("/api-key/request", payload);



export const revokeApiKey = (request_id) => api.delete(`/api-key/ip-request/${request_id}`);
